import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { ExternalLink } from 'lucide-react';

// Fix for default marker icon
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

L.Marker.prototype.options.icon = DefaultIcon;

interface MapViewProps {
  latitude: number;
  longitude: number;
  name?: string;
  className?: string;
}

export function MapView({
  latitude,
  longitude,
  name = 'ตำแหน่งฟาร์ม',
  className = '',
}: MapViewProps) {
  const position: [number, number] = [latitude, longitude];
  const googleMapsUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;

  return (
    <div className={`relative ${className}`}>
      <MapContainer
        center={position}
        zoom={15}
        scrollWheelZoom={true}
        style={{ height: '100%', width: '100%', borderRadius: '0.5rem' }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={position}>
          <Popup>
            <div className="text-center">
              <p className="font-semibold text-sm mb-2">{name}</p>
              <p className="text-xs text-gray-600 mb-3">
                {latitude.toFixed(6)}, {longitude.toFixed(6)}
              </p>
              <a
                href={googleMapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-3 py-1.5 bg-primary-800 text-white text-xs rounded hover:bg-primary-900 transition-colors"
              >
                <ExternalLink className="w-3 h-3" />
                เปิดใน Google Maps
              </a>
            </div>
          </Popup>
        </Marker>
      </MapContainer>

      {/* Button to open in Google Maps */}
      <div className="absolute top-4 right-4 z-[1000]">
        <a
          href={googleMapsUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-4 py-2 bg-white text-primary-800 text-sm font-medium rounded-lg shadow-md hover:shadow-lg hover:bg-primary-50 transition-all duration-200"
        >
          <ExternalLink className="w-4 h-4" />
          เปิดใน Google Maps
        </a>
      </div>
    </div>
  );
}

export default MapView;
